module.exports = __webpack_public_path__ + "img/art-38.502bb95e.png";